<template>
    <v-row
        align-content="center"
        justify="center">
        <v-col
            class="subtitle-1 text-center"
            cols="8" md="12">
            {{ text }}
        </v-col>
        <v-col cols="8" md="4">
            <v-progress-linear
            color="deep-purple accent-4"
            indeterminate
            rounded
            height="6"
            ></v-progress-linear>
        </v-col>
    </v-row>
</template>

<script>
import State from '../../services/state'

export default {
    name: 'preloader',
    props: [ 'text' ],
    data() {
        return {
            show: true,
            State
        }
    }
}
</script>
